import React, { useState, useEffect } from 'react';
import PubSub from 'services/PubSub/';
import LoginService from 'services/Login/';
import Loader from 'components/Loader';
import TagManagerService from 'services/TagManager';
import PropTypes from 'prop-types';
import StorageService from 'services/StorageService';
import style from './style.scss'; //NOSONAR

let accessKey = null
let _password = null
let _register = null

const ValidationCode = (props) => {
    const [isLoading, setIsLoading] = useState(false)
    const [inputIsValid, setInputIsValid] = useState(false)
    const [showInvalidInput, setShowInvalidInput] = useState(false)
    const [email, setEmail] = useState('')
    const [incorrectCode, setIncorrectCode] = useState(false)
    const [isNotRegistred, setIsNotRegistred] = useState(false)
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [offersValue, setOffersValue] = useState(false);
    const [modeUpdate, setModeUpdate] = useState(false)

    let formMessage = 'Campo obligatorio'
    let codeIncorrectMessage = 'La clave de acceso no es válida. Verifica el código'

    const _open = (payload) => {
        const { email: emailUser, password, register, firstName: firstNameUser, lastName: lastNameUser, isNewsletterOptIn, modeUpdate: _modeUpdate } = payload.value
        _password = password;
        _register = register || null;

        setIsLoading(false)
        setInputIsValid(false)
        setShowInvalidInput(false)
        setEmail(emailUser)
        setIncorrectCode(false)
        setIsNotRegistred(false)
        setFirstName(firstNameUser)
        setLastName(lastNameUser)
        setOffersValue(isNewsletterOptIn)
        setModeUpdate(_modeUpdate)
    }

    useEffect(() => {
        const { payload } = props
        if (payload) {
            _open(payload)
        }

    }, [props.payload])

    const _close = () => {
        setTimeout(() => PubSub.dispatch('validation_code_close'), 0)
    }

    const goBack = () => {
        _close()

        PubSub.dispatch('forgot_password_open', {
            email: email,
            register: _register,
        })
    }

    const handleChange = (event) => {
        const value = event.target.value
        if (value.length >= 6) {
            setInputIsValid(true)
            setShowInvalidInput(true)

            accessKey = value
        } else if (value.length === 0) {
            setIncorrectCode(false)
        } else {
            setInputIsValid(false)
            setShowInvalidInput(false)
        }
    }

    const _stopLoading = () => {
        setIsLoading(false)
    }

    const submit = (event) => {
        event.preventDefault()
        if (!(inputIsValid && accessKey && email && _password)) return false

        setIsLoading(true)

        LoginService.updatePassword(accessKey, email, _password).then(sessionData => {
            if (sessionData && sessionData.authStatus === 'Success') {
                StorageService.removeItem('tokenEmail');

                if (!_register) {
                    if (!(sessionData.user && sessionData.user.email && sessionData.user.firstName && sessionData.user.lastName)) {
                        setIsNotRegistred(true)
                        _stopLoading()
                        return false
                    } else {
                        TagManagerService.interaction('Step 2: Ingresa tu código', 'Recuperación exitosa', 'Recuperación de contraseña');
                        setLogin(sessionData)
                    }
                } else {
                    LoginService.registerUser(_register, sessionData.token).then(result => {
                        if (result && result.status && result.status === 200) {
                            TagManagerService.interaction('Step 3: Ingresa tu código', 'Registro exitoso', 'Registro');
                            if (!sessionData.user.firstName) {
                                sessionData.user.firstName = firstName
                            }
                            if (!sessionData.user.lastName) {
                                sessionData.user.lastName = lastName
                            }
                            if (!sessionData.user.isNewsletterOptIn) {
                                sessionData.user.isNewsletterOptIn = offersValue
                            }
                            setLogin(sessionData)
                        } else if (result && result.token) {
                            setLogin(result)
                        } else {
                            _stopLoading()
                        }
                    })
                }
            } else {
                setIsLoading(false)
                setIncorrectCode(true)
                setShowInvalidInput(false)
                if(_register){
                    TagManagerService.interaction('Step 3: error', 'Código inválido', 'Registro')
                } else {
                    TagManagerService.interaction('Step 2: error', 'Código inválido', 'Recuperación de contraseña')
                }
            }
        })
    }

    const setLogin = (sessionData) => {
        LoginService.setLogin(sessionData)
        if (!modeUpdate) {
            PubSub.dispatch('modal_feedback_register_open')
        } else {
            PubSub.dispatch('open_snackbar',{
                TitleMobile: 'La contraseña se cambió correctamente',
                TitleDesktop: 'La contraseña se cambió correctamente',
                timer: 1000 * 10,
                type: 'changePassword',
            });
        }
        _stopLoading()
        _close()
    }

    const goRegister = (event) => {
        event.preventDefault()

        _close()

        PubSub.dispatch('register_open', { email: email })
    }

    const resendCode = () => {
        setIsLoading(true);

        LoginService.sendUserAccessKey(email).then(() => {
            setIsLoading(false);
            setTimeout(() => {
                PubSub.dispatch('open_snackbar', {
                    TitleMobile: 'Hemos reenviado el código a tu mail',
                    TitleDesktop: `Hemos reenviado el código a tu mail`,
                    timer: 8000,
                    type: 'resendCode',
                });
            }, 0)
        })
    }

    const isRut = email.indexOf('@') === -1;

    return(
        <div className="new-modal-container">
            <div className="new-modal-title-wrap"><h3 className="new-modal-title">Ingresa tu código</h3></div>
            <div className={'new-modal-scroll'}>
                {isLoading && <div className="login-validation-code-loader"><Loader/></div>}
                <form className="input-wrapper-validation" onSubmit={submit}>
                    <label className="label-validation">
                        <div className="label-text-validation">
                            Para finalizar, <br/>
                            ingresa el código enviado {isRut ? ' a tu correo': ' a:'}
                        </div>
                        <div className="label-mail-validation">
                            {!isRut ? email : ''}
                        </div>
                    </label>
                    {!isNotRegistred && <div className="contact-validation-container input-wrapper"> 
                        <span className="validation-title"> Código </span> 
                        <input onChange={handleChange} className={'input-validation input-default' + ((incorrectCode || !(inputIsValid || !showInvalidInput)) ? ' input-error' : '')} placeholder={'Eje: 12345'}/> 
                        {!(incorrectCode && !showInvalidInput) ? '' : <p className=" input-error-message">{codeIncorrectMessage}</p>}
                        {!(incorrectCode && !showInvalidInput) ? '' : <i className="jumbo-icon-new-close"></i>}
                        {(inputIsValid || !showInvalidInput) ? '' : <p className=" input-error-message">{formMessage}</p>}
                    </div>}
                    {!isNotRegistred && <div className="contact-validation-resend">
                        No me llegó el código <a className="new-link contact-validation-code" onClick={resendCode}>Reenviar</a>
                    </div>}
                    {!isNotRegistred && <div className="contact-validation">
                        Si tienes cualquier problema, contáctate al <a className="contact-validation-number">600 400
                        3000</a>
                    </div>}
                    {isNotRegistred &&
                    <p className="modal-validation-code-not-registred">Este mail no está asociado a una cuenta en
                        Jumbo.cl, regístrate y comienza a comprar.</p>}
                </form>
            </div>
            <div className="modal-actions">
                <button type="button" className="secundary-btn" onClick={goBack}>
                    <span>Volver</span>
                </button>
                {isNotRegistred && <button type="submit" className='primary-btn modal-validation-code-change-pasword' onClick={goRegister}>Regístrate</button>}
                {!isNotRegistred && <button type="submit" onClick={submit} className={inputIsValid ? 'primary-btn' : 'disabled-btn'}>
                    <span className="modal-validation-code-change-pasword">Confirmar</span>
                </button>}
            </div>
        </div>
    )
}

ValidationCode.propTypes = {
    payload: PropTypes.object,
}

export default ValidationCode
